<div *ngIf="drawerData" [finderScrollTo]="linkId" class="drawer-link">
    <div class="link-title" (click)="click($event)">
        <finder-font-icon *ngIf="!drawerData.hideIcon"
            [name]="norgie"
            class="link-icon"
        ></finder-font-icon>
        <a href="#"
            tabindex="0"
            finderLinkId
            class="link"
            [ngClass]="{'show-caret': isExpanded}"
            role="button"
            [attr.id]="sourceId"
            [attr.aria-expanded]="isExpanded"
            [attr.aria-label]="drawerData.title"
            [attr.aria-controls]="sourceId.replace('-link','')"
            [innerHTML]="drawerData.title | safeHtml"
        ></a>
    </div>
    <finder-campaign-drawer-detail [groupId]="linkId"></finder-campaign-drawer-detail>
    <div class="drawer-copy">
        <span class="title">{{drawerData.header}}</span>
        <span class="copy">{{drawerData.copy}}</span>
    </div>
</div>
